import {Theme} from "@mui/material";
import {SxProps} from "@mui/system";
import {merge} from "lodash";
import React, {useMemo} from "react";
import ReactApexChart from "react-apexcharts";
import {Colors} from "../../colors";
import {Container} from "../Container";
import BaseOptionChart from "./BaseOptionChart";

const CHART_HEIGHT = 120;
const TRACK_BG = Colors.grey._300;

type ProgressCircleChartProps = {
  percent: number;
  sx?: SxProps<Theme>;
};

const ProgressCircleChart: React.FC<ProgressCircleChartProps> = ({percent, sx}) => {
  const COLOR = useMemo(() => Colors.primary._800, []);

  const chartOptions = merge(BaseOptionChart(), {
    labels: [""],
    legend: {show: false},
    fill: {
      type: "gradient",
      gradient: {
        colorStops: [
          [
            {offset: 0, color: COLOR, opacity: 1},
            {offset: 100, color: COLOR, opacity: 1},
          ],
        ],
      },
    },
    chart: {
      height: CHART_HEIGHT,
      parentHeightOffset: 0,
    },
    stroke: {lineCap: "butt", width: 0},
    grid: {padding: {top: 0, bottom: 0, left: 0, right: 0}},
    states: {
      hover: {filter: {type: "none"}},
      active: {filter: {type: "none"}},
    },
    plotOptions: {
      radialBar: {
        hollow: {size: "35%"},
        track: {background: TRACK_BG},
        dataLabels: {
          name: {show: false},
          value: {
            fontSize: "14px",
            offsetY: 5,
            formatter: () => `${percent}%`,
          },
        },
      },
    },
  });

  return (
    <Container
      sx={{
        "& .apexcharts-canvas svg, & .apexcharts-canvas foreignObject": {
          overflow: "visible",
        },
        ...sx,
      }}
    >
      <ReactApexChart
        type="radialBar"
        series={[percent]}
        options={chartOptions}
        height={CHART_HEIGHT}
        width={CHART_HEIGHT * 0.8}
      />
    </Container>
  );
};

export default ProgressCircleChart;
